module.exports = __webpack_public_path__ + "r-v3/img/mobile_premium_feature_001.ca5a85cd.jpg";